module.exports = __webpack_public_path__ + "static/daniel-ek-7d27337d651968a1f58f9bb6d70cb507.jpg";